$(document).ready(function(){
  
// $('.brand-section-main .block__brand--content').not('.slick-initialized').slick({
//     autoplay: !0,
//     slidesToShow: 10,
//     slidesToScroll: 1,
//     arrows: !1,
//     draggable: !1,
//     adaptiveHeight: !0,
//     speed: 1e4,
//     infinite: !0,
//     pauseOnHover: !1,
//     autoplaySpeed: 0,
//     cssEase: "linear",
//     vertical: !1,
//     verticalSwiping: !1,
//     focusOnSelect: !0,
//     variableWidth: !0,
//     responsive: [{
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 7,
//         slidesToScroll: 1
//       }
//     }  
//   ]
//   }); 


}); 


$(document).ready(function(){ 
  $('.brand-section-main .block__brand--content').owlCarousel({
    items:5,
    loop:true,
    nav:false,
    loop:true,
    smartSpeed:10,
    responsiveClass: true,
    responsiveRefreshRate : 1,
    dots:false,
    margin:10,
    autoplay:true,
    autoplay: true,
    slideTransition: 'linear',
    autoplayTimeout: 5000,
    autoplaySpeed: 5000,
    autoplayHoverPause: false,
    responsive:{
        0:{
            items:3
        },
        600:{
            items:4
        },
        992:{
            items:8
        },
        1200:{
            items:12
        }
    }
})
}); 


//  $('.collection_awardSlidercontainer').not('.slick-initialized').slick({
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   infinite: true,
//   swipeToSlide: true,
//   centerMode: true,
//   focusOnSelect: true,
//   speed: 5000,
//   pauseOnHover: true,
//   dots: 'false',
//     arrows: false,
//     responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 5,
//         slidesToScroll: 1
//       }
//     },
//     { 
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

// $(document).ready(function(){
//     var owlCarousel = $('.collection_awardSlidercontainer');
//     var windowWidth = $(window).width();
// if (owlCarousel.length) 
//     if (owlCarousel.children().length > 6) {
//         // If more than 5 children, initialize carousel with 5 items
//         initializeCarousel(6);
//     } else if (owlCarousel.children().length > 4) {
//         // If 3 to 5 children, initialize carousel with a dynamic number of items based on window width
//         if (windowWidth > 1500) {
//             owlCarousel.removeClass('owl-carousel');
//         } else {
//             initializeCarousel(5);
//         }
//     } else {
//         owlCarousel.removeClass('owl-carousel');
//         owlCarousel.data('owl.carousel').destroy();
//     }
// }


//     function initializeCarousel() {
//         owlCarousel.trigger('refresh.owl.carousel');
//         owlCarousel.addClass('owl-carousel');
//         var mLoopValue = owlCarousel.attr('m-loop');
//         var deskValue = owlCarousel.attr('data-desk');
//         var tabletValue = owlCarousel.attr('data-tablet');
//         var mobileValue = owlCarousel.attr('data-mobile');

//         owlCarousel.owlCarousel({
//             items: deskValue,
//             loop: true,
//             nav: false,
//             dots: false,
//             margin: 10,
//             autoplay: true,
//             slideTransition: 'linear',
//             autoplayTimeout: 5000,
//             autoplaySpeed: 5000,
//             autoplayHoverPause: true,
//             responsive:{
//                 0:{
//                     items: mobileValue,
//                     loop:mLoopValue
//                 },
//                 600:{
//                     items: mobileValue
//                 },
//                 992:{
//                     items: tabletValue
//                 },
//                 1200:{
//                     items: deskValue
//                 }
//             }
//         });
//     }
// });

$(document).ready(function() {
    function initializeCarousel() {
        var owlCarousel = $('.collection_awardSlidercontainer');
        var windowWidth = $(window).width();
        var dLoopValue = owlCarousel.attr('d-loop');
        var mLoopValue = owlCarousel.attr('m-loop');
        var deskValue = owlCarousel.attr('data-desk');
        var tabletValue = owlCarousel.attr('data-tablet');
        var mobileValue = owlCarousel.attr('data-mobile');
        var productAwardSliderItemsLength = $('.productAwardSlider_slide').length; 
        if (productAwardSliderItemsLength === 0) {
               owlCarousel.parents('.shopify-section').hide();
            }
        owlCarousel.trigger('refresh.owl.carousel');
        owlCarousel.addClass('owl-carousel');

        owlCarousel.owlCarousel({
            items: deskValue,
            nav: false,
            dots: false,
            margin: 10,
            autoplay: productAwardSliderItemsLength > deskValue,
            slideTransition: 'linear',
            autoplayTimeout: 5000,
            autoplaySpeed: 5000,
            autoplayHoverPause: true,
            responsive:{
                0:{
                    items: mobileValue,
                    loop: productAwardSliderItemsLength > mobileValue,
                    autoplay: productAwardSliderItemsLength > mobileValue
                },
                600:{ 
                    items: mobileValue,
                    loop: productAwardSliderItemsLength > mobileValue,   
                    autoplay: productAwardSliderItemsLength > mobileValue
                },
                992:{
                    items: tabletValue,
                    loop: productAwardSliderItemsLength > tabletValue,
                    autoplay: productAwardSliderItemsLength > tabletValue
                },
                1200:{
                    items: deskValue,  
                    loop: productAwardSliderItemsLength > deskValue,
                    autoplay: productAwardSliderItemsLength > deskValue
                }
            }
        });
    }
    initializeCarousel();
});






//  $(document).ready(function(){
//   $('.collection_awardSlidercontainer').owlCarousel({
//     items:4,
//     loop:true,
//     nav:false,
//     dots:false,
//     margin:10,
//     autoplay:true,
//     autoplay: true,
//     slideTransition: 'linear',
//     autoplayTimeout: 5000,
//     autoplaySpeed: 5000,
//     autoplayHoverPause: true,
//     responsive:{
//         0:{
//             items:3
//         },
//         600:{
//             items:4
//         },
//         992:{
//             items:6
//         },
//         1200:{
//             items:8
//         }
//     }
// })
// });